import 'react-circular-progressbar/dist/styles.css';

import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import React, { useContext, useEffect, useState } from 'react';
import styled, { ThemeContext } from 'styled-components';

import { colors } from '../../utils/styles';
import { navigate } from 'gatsby-link';

const getRandomInt = (min, max) => {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min);
};

export const LoadingScreen = ({ uid }) => {
  const [percentage, setPercentage] = useState(0);

  const theme = useContext(ThemeContext);

  useEffect(() => {
    if (percentage >= 100) {
      navigate(`/quiz/${uid}/overview`);
    }
  }, [percentage]);

  useEffect(() => {
    const interval = setInterval(() => {
      const step = getRandomInt(1, 15);
      setPercentage(prev => {
        const newPercentage = prev + step;
        if (newPercentage >= 100) {
          return 100;
        }
        return newPercentage;
      });
    }, 300);
    return () => clearInterval(interval);
  }, []);

  const styles = buildStyles({
    strokeLinecap: 'round',
    pathColor: theme.primary,
    trailColor: theme.secondary,
    backgroundColor: 'red',
    textColor: colors.black,
  });

  return (
    <Wrap>
      <StyledLoader value={percentage} text={`${percentage}%`} styles={styles} />
    </Wrap>
  );
};

const StyledLoader = styled(CircularProgressbar)`
  width: 150px;
  height: 150px;
  margin: 0 auto;
`;

const Wrap = styled.div`
  text-align: center;
`;
